export const ThemeConst = {
  token: {
    primaryColor: "#0AA4DA", // Màu chủ đạo của bạn
    secondaryColor: "#F9F9F9", // Ví dụ màu phụ
    itemSelectedColor: "#0AA4DA",
    inkBarColor: "#0AA4DA",
    itemActiveColor: "#0AA4DA",
    itemHoverColor: "#0AA4DA",

    // colorPrimary: "#FFF",
  },
  components: {
    // Các token cho Pagination và các component khác
    Pagination: {
      colorPrimary: "#FFF",
      itemBg: "#F6F6F6", // Nền của các nút không được chọn
      itemColor: "#000", // Màu chữ của các nút không được chọn
      itemHoverBg: "#0AA4DA", // Nền khi hover
      itemHoverColor: "#fff", // Chữ khi hover
      itemActiveBg: "#0AA4DA", // Nền của nút đang chọn
      // itemActiveColor: "#fff", // Chữ của nút đang chọn
      itemBorderColor: "transparent", // Bỏ đường viền
      itemHoverBorderColor: "transparent", // Bỏ đường viền khi hover
      itemActiveBorderColor: "transparent", // Bỏ đường viền khi chọn
    },
    Tabs: {
      itemSelectedColor: "#0AA4DA",
    },
  },
};
